import { render } from "./ResidentUpdatePage.vue?vue&type=template&id=c445894e&ts=true"
import script from "./ResidentUpdatePage.vue?vue&type=script&lang=ts"
export * from "./ResidentUpdatePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__